<template>
  <div class="questionPage">
    <div :class="[orgtype == 'juzi'  ? 'logo-j' : 'logo-c', 'logo2']"></div>
    <div class="questionWrap">
      <div class="list">
        <div class="itemA">
          <div class="title">{{currentInfo.title}}</div>
          <div class="itemB flex" v-for="(itemB, indexB) in currentInfo.arr" :key="indexB" @click="choose(indexB)">
            <div :class="[itemB.isChoose ? 'active' : '', 'chooseBtn']"></div>
            <div class="name">{{itemB.name}}</div>
          </div>
        </div>
      </div>
      <div v-if="type == 1" :class="[currentIndex ? 'flex-js-ac' : 'flex-jsa', 'btnWrap btnWrap1']">
        <div class="back comBtn" v-if="currentIndex" @click="goNext(0)">上一步</div>
        <div class="next comBtn" @click="goNext(1)">下一步</div>
      </div>
      <div v-else-if="type == 2" class="btnWrap flex-jsa">
        <div class="go comBtn" @click="goList">打开您的私人定制</div>
      </div>
    </div>
  </div>
</template>

<script>
import {customRequestAjax} from '@/axiosApi'
import { parametersCombine, isWeixin, fenxiang, isApp } from '../../assets/common/js/config'
import wx from 'weixin-js-sdk'
export default {
  name: "skinAnalysis",
  data() {
    return {
      list1: [
        {
          title: 'Q:您是否了解自己的肤质？',
          arr: [
            {
              name: 'A.干性',
              isChoose: false,
            },
            {
              name: 'B.中性',
              isChoose: false,
            },
            {
              name: 'C.油性',
              isChoose: false,
            },
            {
              name: '混合偏干',
              isChoose: false,
            },
            {
              name: '混合偏油',
              isChoose: false,
            },
          ]
        },
        {
          title: 'Q:您的皮肤类型？',
          arr: [
            {
              name: 'A.不敏感',
              isChoose: false,
            },
            {
              name: 'B.轻微敏感，使用正常护肤品，但会考虑下产品的温和型',
              isChoose: false,
            },
            {
              name: 'C.非常敏感',
              isChoose: false,
            }
          ]
        },
      ],
      list2: [
        {
          title: 'Q:您目前最想解决的肌肤问题是？',
          arr: [
            {
              name: '基础护肤',
              isChoose: false,
            },
            {
              name: '紧致抗衰',
              isChoose: false,
            },
            {
              name: '提亮肤色',
              isChoose: false,
            },
            {
              name: '眼部问题',
              isChoose: false,
            },
            {
              name: '紧致毛孔',
              isChoose: false,
            }
          ]
        }
      ],
      listJz: [
        {
          title: 'Q:您目前最想解决的肌肤问题是？',
          arr: [
            {
              name: '基础护肤',
              isChoose: false,
            },
            {
              name: '紧致抗衰',
              isChoose: false,
            },
            {
              name: '提亮肤色',
              isChoose: false,
            },
            {
              name: '痘痘粉刺',
              isChoose: false,
            },
            {
              name: '紧致毛孔',
              isChoose: false,
            }
          ]
        }
      ],
      list: [],
      currentIndex: 0,
      currentInfo: null,
      type: null,
      orgtype: null
    };
  },
  created() {
    let type = this.$route.query.type, list;
    this.type = null // 重置type
    this.orgtype = this.$route.query.orgtype
   console.log(window.location.href)
		console.log(this.$route.query.orgtype)
    if (type == 1) {
      list = this.list1
    } else {
      list = this.orgtype == 'juzi' ? this.listJz : this.list2
    }
    this.type = type
    this.currentInfo = list[this.currentIndex]
    this.list = list
		this.share()
  },
  methods: {
    share() {
			if (isWeixin()) {
				var arg = isApp(), shareInfo;
				shareInfo = {
					title: encodeURIComponent('皮肤测试'),
					desc: encodeURIComponent('AI皮肤测试，充分了解您你的皮肤状况！'),
					type: 'skinAnalysis',
					path: 'skinAnalysis',
					dataStr: 'type=skinAnalysis&emptybottle=emptybottle&orgtype=' + this.orgtype,
          imgx: this.staticImgUrl + 'Uploads/share/ndo1.png'
				}
				if (arg.indexOf('xcx') >= 0) {
          shareInfo = {
            type: 'skinAnalysis',
            title: encodeURIComponent('皮肤测试'),
            link: basepath + 'skinAnalysis?path=' + (this.$route.query.path ? this.$route.query.path : '') + arg,
            img: this.staticImgUrl + 'Uploads/share/ndo1.png'
          }
					wx.miniProgram.postMessage({data: shareInfo})
				} else {
					fenxiang(shareInfo)
				}
			}
		},
    choose(indexB) {
      let list = this.list

      for (let i = 0; i < list.length; i++) {
        if (i == this.currentIndex) {
          let arr = list[i].arr
          for (let j = 0; j < arr.length; j++) {
            if (j != indexB) {
              arr[j].isChoose = false
            } else {
               arr[j].isChoose = true
            }
          }
        }
      }
    },
    // 上一步，下一步
    goNext(next) {
      if (next == 0) {
        this.currentIndex = this.currentIndex - 1
      } else {
        let currentList = this.list[this.currentIndex].arr, flag = 0;
        for (let i = 0; i< currentList.length; i++) {
          if (currentList[i].isChoose) {
            flag = 1
            break
          }
        }
        if (!flag) {
          this.$toast('请选择当前问题')
          return
        }
        if (this.currentIndex < this.list.length - 1) {
          this.currentIndex = this.currentIndex + 1
        } else {
          let query = parametersCombine()
          query.source = 'analysis'
          query.orderid = this.$route.query.orderid
          query.sex = this.$route.query.sex
          query.orgtype = this.orgtype
          this.$router.push({
            path: '/analysisDetail',
            query: query
          })
          return
        }
      }
      this.currentInfo = this.list[this.currentIndex]
    },
    // 跳转至推荐商品列表
    goList() {
      let list = this.currentInfo.arr, problemType = 0, url = 'Wxmall/YiYuanApi/saveResult', params;
      for (let i = 0; i < list.length; i++) {
        if (list[i].isChoose) {
          problemType = i + 1
          break;
        }
      }
      if (!problemType) {
        this.$toast('请选择当前问题')
        return
      }

      params = {
        orderid: sessionStorage.getItem('detail_id'),
        sex: sessionStorage.getItem('sex') || 1,
        problemType: problemType
      }

      if (this.orgtype == 'juzi') {
        url = 'Wxmall/YiYuanApickys/saveResult'
      }

      customRequestAjax.post(url, params).then(res => {
        if (res.data.code === 200) {
          let query = parametersCombine()
          this.$router.push({
            path: '/skinProducts',
            query: query
          })
        } else {
          this.$toast(res.msg || '提交失败，请稍后重试！')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.questionPage {
  position: relative;
  background: url("/static/images/skinAnalysis/skin_bg.png") no-repeat;
  background-size: 100%;
  background-color: #ff7ba9;
  font-size: 0.14rem;
  .logo2 {
    margin: 0.1rem auto;
    height: 0.45rem;
    &.logo-c {
      width: 1rem;
      background: url("/static/images/skinAnalysis/logo-c.png") no-repeat;
      background-size: 100%;
    }
    &.logo-j {
      width: 1.87rem;
      background: url("/static/images/skinAnalysis/logo-j.png") no-repeat;
      background-size: 100%;
    }
  }
  .questionWrap {
    position: relative;
    top: 20%;
    left: 50%;
    width: 80%;
    transform: translateX(-50%);
    .list {
      padding: 0.24rem 0.2rem 0.2rem;
      border-radius: 0.4rem;
      background: #FF79AA;
      box-sizing: border-box;
      color: #fff;
    }

    .title {
      margin-bottom: 0.2rem;
      font-size: 0.16rem;
      text-align: center;
    }

    .itemB {
      .chooseBtn {
        margin: 0.08rem 0.1rem 0 0;
        width: 0.18rem;
        height: 0.18rem;
        background: url("/static/images/skinAnalysis/default.png") no-repeat;
        background-size: 100%;
        &.active{
          background: url("/static/images/skinAnalysis/selected.png") no-repeat;
          background-size: 100%;
        }
      }
      .name {
        flex: 1;
      }
      line-height: 0.34rem;
    }
  }
  .btnWrap {
    margin: 0.2rem auto;
    text-align: center;
    color: #FF79A8;
    &.btnWrap1 {
      width: 2rem;
    }
    .comBtn {
      background: #fff;
      padding: 0.1rem 0.2rem;
      border-radius: 0.18rem;
    }
  }

  .flex-js-ac {
    display: flex;
    align-items: center;
  }

  .flex-jsa {
    display: flex;
    justify-content: space-around;
  }

  .flex {
    display: flex;
  }

  .flex-ac {
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/skinAnalysis/question.vue